import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import CruisePriceRoomTypeInfo from './CruisePriceRoomTypeInfo'
import OfferPageStickyFooter from 'components/OfferPage/OfferPageStickyFooter'
import { CruiseContentSections } from 'constants/cruise'
import Group from 'components/utils/Group'
import type { CruiseOfferPriceVariation } from 'lib/cruises/cruiseUtils'

interface Props {
  onView: (ref: string) => void
  offer: App.CruiseOffer
  priceFrom: App.CruisePriceDetails
  price: CruiseOfferPriceVariation
  memberPrice?: CruiseOfferPriceVariation
  memberPriceType?: App.Cruises.CruiseMemberPriceType
  hasValidDepartures?: boolean
  visible: boolean
}

function CruiseStickyFooter(props: Props) {
  const intl = useIntl()
  const { onView, priceFrom, price, memberPrice, memberPriceType, visible, hasValidDepartures, offer } = props

  const onCTAClick = useCallback(() => onView(CruiseContentSections.DEPARTURES), [onView])

  return (
    <OfferPageStickyFooter
      visible={visible}
      callToActionCopy={intl.formatMessage({
        id: 'Xd_zizMcQ1go2SEZLd48',
        defaultMessage: 'Check Availability',
        description: 'Button label to check cruise availability in the cruise section',
      })}
      onCTAClick={onCTAClick}
      callToActionDisabled={!hasValidDepartures}
    >
      <Group direction="horizontal" verticalAlign="center" horizontalAlign="space-between" tabletGap={16}>
        <CruisePriceRoomTypeInfo
          priceFrom={priceFrom}
          price={price}
          memberPrice={memberPrice}
          memberPriceType={memberPriceType}
          hasValidDepartures={hasValidDepartures}
          offer={offer}
        />
      </Group>
    </OfferPageStickyFooter>
  )
}
export default CruiseStickyFooter
